// extracted by mini-css-extract-plugin
export var container = "_7p-0";
export var icon = "_7p-1";
export var text = "_7p-2";